jQuery(document).ready(function ($) {
    'use strict';

    // Open vaccination overlay
    $( document ).on( 'click', '.open-vaccination-overlay', function(){
        $('.vaccination-overlay').css('display', 'flex');
    });

    // close vaccination overlay
    $( document ).on( 'click', '.close-vaccination-overlay', function(){
        $('.vaccination-overlay').css('display', 'none');
    });
    $('.vaccination-overlay').on('click', function (e) {
        if (e.target !== this)
            return;

        $(this).css('display', 'none');
    });
  
});